import { Button, Divider, Flex, FormControl, FormLabel, HStack, Icon, SimpleGrid, VStack, Text } from '@chakra-ui/react'
import { BsSearch } from 'react-icons/bs'
import { useForm } from 'react-hook-form'
import { SelectMonth, SelectYear,SelectContractStatus } from '../shared'
import { useSearchQueryContext } from '../../context/searchQueryContext'
import { useEffect, useRef } from 'react'

const ContractSearchForm = () => {
    const { control, handleSubmit } = useForm({})
    const { setQuery } = useSearchQueryContext()
    const now = new Date()
    const defaultQuery = {
        month : (now.getMonth()+1).toString().padStart(2, '0'),
        year: now.getFullYear(),
        status : 'ACTIVE',
    }

    const ref = useRef(null)
    ref.current = ()=>{
        const q = "?" + Object.keys(defaultQuery).map(k => `${k}=${defaultQuery[k] || ''}`).join('&')
        setQuery(q)
    }
    useEffect(()=>{
        ref.current()
    },[])

    const onSubmit = (data) => {
        const q = "?" + Object.keys(data).map(k => `${k}=${data[k]?.value || ''}`).join('&')
        setQuery(q)
    }
    return (
        <form onSubmit={handleSubmit(onSubmit)} style={{ width: "100%" }}>
            <VStack mt={4} w="full" align="center">
                <SimpleGrid w="full" columns={3} spacing={2}>
                    <FormControl>
                        <FormLabel>วันที่ทำสัญญา (เดือน)</FormLabel>
                        <SelectMonth control={control} defaultValue={defaultQuery.month} />
                    </FormControl>
                    <FormControl>
                        <FormLabel>วันที่ทำสัญญา (ปี)</FormLabel>
                        <SelectYear control={control} defaultValue={defaultQuery.year} />
                    </FormControl>
                    <FormControl>
                        <FormLabel>สถานะสัญญา</FormLabel>
                        <SelectContractStatus control={control} defaultValue={defaultQuery.status} />
                    </FormControl>
                </SimpleGrid>
                <HStack>
                    <Button type="submit" colorScheme="blue" fontSize="md" leftIcon={<BsSearch />}>
                        ค้นหา
                    </Button>
                </HStack>
            </VStack>
        </form>
    )
}

const ContractSearchPanel = () => {
    return (
        <Flex w="full" direction="column" p={4} shadow="lg" borderRadius={4}>
            <Text><Icon as={BsSearch} mr={2} />ค้นหา</Text>
            <Divider />
            <ContractSearchForm />
        </Flex>
    )
}

export default ContractSearchPanel